import React, { useCallback, useEffect, useState } from 'react';
import { cryptoPortfolioService } from '../../services/cryptoPortfolioService';
import AiTuneChangeTable from '../admin/AiTuneChangeTable';

export interface ActivityBotAiTuneRegimeReviewProps {
  botId: number;
  active: boolean;
}

const ActivityBotAiTuneRegimeReview: React.FC<ActivityBotAiTuneRegimeReviewProps> = ({
  botId,
  active,
}) => {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState<Array<Record<string, unknown>>>([]);

  const load = useCallback(async () => {
    if (!botId) return;
    setLoading(true);
    try {
      const res = await cryptoPortfolioService.getActivityBotAiRegimeReview(botId);
      setEvents((res.tuneEvents as Array<Record<string, unknown>>) ?? []);
    } finally {
      setLoading(false);
    }
  }, [botId]);

  useEffect(() => {
    if (active) void load();
  }, [active, load]);

  if (loading) return <p style={{ fontSize: 13, color: '#6b7280' }}>Loading review…</p>;

  if (events.length === 0) {
    return (
      <div style={{ padding: 16, background: '#f9fafb', borderRadius: 8, color: '#6b7280', fontSize: 13 }}>
        No tune events yet — regime review will populate after the first AI tune run.
      </div>
    );
  }

  return (
    <div>
      <p style={{ fontSize: 13, color: '#6b7280', marginTop: 0 }}>
        Recent AI tune events and regime labels for this activity bot.
      </p>
      {events.map((ev, idx) => (
        <div key={idx} style={{ marginBottom: 12, padding: 12, border: '1px solid #e5e7eb', borderRadius: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 700 }}>
            {ev.appliedAt ? new Date(String(ev.appliedAt)).toLocaleString() : '—'} · {String(ev.marketRegime ?? '—')} · {String(ev.outcome ?? '—')}
          </div>
          <AiTuneChangeTable changes={(ev.changes as Array<{ field: string; label: string; before: string; after: string }>) ?? []} compact />
        </div>
      ))}
    </div>
  );
};

export default ActivityBotAiTuneRegimeReview;
